export default {
    tasks: {
        taskManagement: "Task Management",
        serviceName: "Service",
        name:"Task",
        enabled:"Enabled",
        runJobs: 'Run Jobs',
        enableJobs: 'Enable Jobs',
        disableJobs: 'Disable Jobs',
        maxRowsSelection: 'Maximum {limit} rows can be selected',
        tasksSubmissionSuccess: 'Selected tasks got submitted successfully',
        tasksSubmissionFail: 'Selected tasks got failed to submit',
        customer: "Customer",
        schedule: "Schedule",
        priority: "Priority",
        maxRunTime: "Max Run Time (Minutes)",
        nextStartTime: "Next Start Time",
        lastStartTime: "Last Start Time",
        taskType: "Task Type",
        lastStatus: "Last Status",
        lastRunDuration:"Last Run Duration (seconds)",
        lastRunDurationTooltip:"The length of time of the last job run in seconds",
        durationDelta: "Duration Delta",
        durationDeltaTooltip: "The job duration percent change between the average duration of the oldest 3 job executions and the most recent 3. Backfill executions and early runs for incomplete history are excluded.",
        durationDeltaInfo: "Duration Delta Info",
        durationDeltaInfoTooltip: "The values used to calculate the durationDelta",
        details: "Task Details",
        general: "General",
        history: "History",
        startTime: "Start Time",
        endTime: "End Time",
        status: "Status",
        totalTime: "Total Time (Seconds)",
        message: "Message",
        results: "Results",
        numFailures: "Number of Failures",
        numFailuresTooltip: "Number of failures over the last 100 runs",
        priorityValues: {
            HIGH: "HIGH",
            MEDIUM: "MEDIUM",
            LOW: "LOW"
        },
        taskTypeValues: {
            SYSTEM: "SYSTEM",
            USER: "USER"
        },
        statusValues: {
            NEVER_RUN: "NEVER_RUN",
            STARTED: "STARTED",
            FINISHED: "FINISHED",
            FAILED: "FAILED"
        },
        services: {
            alarms: "Alarms",
            history: "History",
            fwdl: "FWDL",
            'radios-tasks': "Radio Tasks",
            'towers-processing': "Base Station Processing",
            'towers-tasks': "Base Station Tasks",
        },
        configureCommsHubExport: 'Configure Start Time'
    }
}
